export default __webpack_public_path__ + "static/media/digital_platforms_s.9aac3a29.jpg";